// Module
var code = "<section class=\"cr-flex-between cursor-pointer\" ng-click=\"$ctrl.updateView()\"> <div class=\"display-date\">{{ ::$ctrl.day.displayDate }}</div> <div class=\"icon-container\"> <div class=\"icon-cr-expand\" ng-if=\"::!$ctrl.isDayView\"></div> <div class=\"icon-cr-contract\" ng-if=\"::$ctrl.isDayView\"></div> </div> </section> ";
// Exports
export default code;